import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class NirlatGiftsService {
  constructor(private http: HttpClient) {}

  getAllNirlatGifts(params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/nirlat-gifts', { params: httpParams });
  }
  createNirlatGift(nirlatGiftData: any) {
    return this.http.post<ApiResponse>('/v1/admin/nirlat-gifts', nirlatGiftData);
  }
  updateNirlatGift(id: string | null, nirlatGiftData: any) {
    return this.http.put<ApiResponse>(`/v1/admin/nirlat-gifts/${id}`, nirlatGiftData);
  }
  deleteNirlatGift(id: string | null) {
    return this.http.delete<ApiResponse>(`/v1/admin/nirlat-gifts/${id}`);
  }
  getNirlatGiftById(id: string | null) {
    return this.http.get<ApiResponse>(`/v1/admin/nirlat-gifts/${id}`);
  }
  exportNirlatGifts(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/nirlat-gifts/export`, filterData, options);
  }
}
